document.addEventListener('DOMContentLoaded', () => {
  const testimonialSections = document.querySelectorAll('.testimonial-slider.is-slider-enabled');

  testimonialSections.forEach(section => {
    const track = section.querySelector('.testimonial-track');
    const cards = Array.from(section.querySelectorAll('.testimonial-card'));
    const dotsContainer = section.querySelector('.testimonial-dots');
    const prevBtn = section.querySelector('.testimonial-arrow--prev');
    const nextBtn = section.querySelector('.testimonial-arrow--next');

    let index = 0;
    let cardsPerSlide = 1;
    let totalSlides = 0;

    /* ===== Swipe Variables ===== */
    let startX = 0, startY = 0, endX = 0;
    let isDragging = false;
    let isDraggingClick = false;//new added
    let gestureLocked = false;
    let gestureDirection = null;
    const threshold = 70;

    // add touchpad scrolling 
  let isThrottled = false;

section.addEventListener('wheel', (e) => {
  if (isThrottled) return;

  const isHorizontalScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY);
  if (!isHorizontalScroll) return;

  e.preventDefault();

  if (e.deltaX > 0 && index < totalSlides - 1) {
    moveTo(index + 1);
  } else if (e.deltaX < 0 && index > 0) {
    moveTo(index - 1);
  }

  isThrottled = true;
  setTimeout(() => {
    isThrottled = false;
  }, 400); // adjust speed here
}, { passive: false });

 //touchpad scrolling end here 

    function getCardsPerSlide() {
      if (window.innerWidth >= 1100) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function setupSlider() {
      cardsPerSlide = getCardsPerSlide();
      index = 0;
      dotsContainer.innerHTML = '';
      totalSlides = Math.ceil(cards.length / cardsPerSlide);

      if (totalSlides <= 1) {
        track.style.transform = 'translateX(0)';
        return;
      }

      for (let i = 0; i < totalSlides; i++) {
        const dot = document.createElement('span');
        dot.className = 'dot';
        if (i === 0) dot.classList.add('active');
        dot.addEventListener('click', () => moveTo(i));
        dotsContainer.appendChild(dot);
      }

      moveTo(0);
    }

    function moveTo(i) {
      index = i;
      const gap = parseInt(getComputedStyle(track).gap) || 0;

      let offset = 0;
      for (let j = 0; j < i * cardsPerSlide; j++) {
        if (!cards[j]) break;
        offset += cards[j].offsetWidth + gap;
      }

      track.style.transform = `translateX(-${offset}px)`;

      dotsContainer.querySelectorAll('.dot').forEach(dot =>
        dot.classList.remove('active')
      );
      if (dotsContainer.children[i]) {
        dotsContainer.children[i].classList.add('active');
      }

      // Update arrow disabled state
if (prevBtn) {
  if (index === 0) prevBtn.classList.add('testimonial-arrow--prev-disabled');
  else prevBtn.classList.remove('testimonial-arrow--prev-disabled');
}

if (nextBtn) {
  if (index >= totalSlides - 1) nextBtn.classList.add('testimonial-arrow--next-disabled');
  else nextBtn.classList.remove('testimonial-arrow--next-disabled');
}
    }

    // handle button clicks
    if (prevBtn) {
  prevBtn.addEventListener('click', () => {
    if (index > 0) {
      moveTo(index - 1); // only go back if not first slide
    }
  });
}

if (nextBtn) {
  nextBtn.addEventListener('click', () => {
    if (index < totalSlides - 1) {
      moveTo(index + 1); // only go forward if not last slide
    }
  });
}

    function handleGesture() {
      const diff = startX - endX;
      if (Math.abs(diff) < threshold) return;

      if (diff > 0 && index < totalSlides - 1) moveTo(index + 1);
      else if (diff < 0 && index > 0) moveTo(index - 1);
    }

    /* =====================================================
       TOUCH EVENTS — APPLY TO WHOLE SECTION (NOT JUST TRACK)
       ===================================================== */
    section.addEventListener('touchstart', e => {
      if (e.touches.length > 1) return;

      isDragging = true;
      gestureLocked = false;
      gestureDirection = null;

      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: false });

    // section.addEventListener('touchmove', e => {
    //   if (!isDragging) return;

    //   const currentX = e.touches[0].clientX;
    //   const currentY = e.touches[0].clientY;
    //   const diffX = currentX - startX;
    //   const diffY = currentY - startY;

    //   if (!gestureLocked) {
    //     if (Math.abs(diffX) > 6 || Math.abs(diffY) > 6) {
    //       gestureLocked = true;
    //       gestureDirection = Math.abs(diffX) > Math.abs(diffY) ? 'x' : 'y';
    //     }
    //   }

    //   // Horizontal swipe → STOP page scroll
    //   if (gestureDirection === 'x') {
    //     e.preventDefault();
    //   }

    //   // Vertical swipe → cancel slider swipe
    //   if (gestureDirection === 'y') {
    //     isDragging = false;
    //   }

    // }, { passive: false });

    section.addEventListener('touchmove', e => {
      if (!isDragging) return;

      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const diffX = currentX - startX;
      const diffY = currentY - startY;

      if (!gestureLocked) {
        // Only lock the gesture if the user has moved more than 5px
        // This filters out "jitter" (tiny movements before a scroll)
        if (Math.abs(diffX) > 5 || Math.abs(diffY) > 5) {
          gestureLocked = true;
          gestureDirection = Math.abs(diffX) > Math.abs(diffY) ? 'x' : 'y';
          
          // CRITICAL: Prevent default as soon as we know it's a horizontal swipe
          if (gestureDirection === 'x') {
            e.preventDefault();
          }
        }
      } else if (gestureDirection === 'x') {
        // Keep preventing default if we have already locked to horizontal
        e.preventDefault();
      }
    }, { passive: false });


    section.addEventListener('touchend', e => {
      if (!isDragging || gestureDirection !== 'x') {
        isDragging = false;
         isDraggingClick = false; // reset
        return;
      }

      endX = e.changedTouches[0].clientX;
      handleGesture();
      isDragging = false;
      isDraggingClick = false;//reset after swipe
    });

    /* ===== Mouse Drag (Desktop) ===== */
    // section.addEventListener('mousedown', e => {
    //   // Only start dragging if it's the left mouse button
    //   if (e.button !== 0) return;
      

    //   isDragging = true;
    //   startX = e.clientX;
    //   e.preventDefault();
    // });

    // section.addEventListener('mouseup', e => {
    //   if (!isDragging) return;
    //   isDragging = false;
    //   endX = e.clientX;
    //   handleGesture();
    // });

    // section.addEventListener('mouseleave', () => {
    //   isDragging = false;
    // });


    //new added
//   section.addEventListener('mousedown', e => {
//   if (e.button !== 0) return; // left click only

//   startX = e.clientX;
//   isDraggingClick = false;

//   const onMouseMove = (ev) => {
//     const diffX = Math.abs(ev.clientX - startX);
//     if (diffX > 5) isDraggingClick = true; // treat as drag
//   };

//   const onMouseUp = (ev) => {
//     document.removeEventListener('mousemove', onMouseMove);
//     document.removeEventListener('mouseup', onMouseUp);

//     if (isDraggingClick) {
//       endX = ev.clientX;
//       handleGesture(); // move slides if it was a drag
//     } else {
//       // optional: handle click on a card if needed
//     }

//     isDraggingClick = false; // reset
//   };

//   document.addEventListener('mousemove', onMouseMove);
//   document.addEventListener('mouseup', onMouseUp);
// });


  
  
  
    setupSlider();
    window.addEventListener('resize', setupSlider);
  });
});
